export default "/images/vendor/flag-icon-css/flags/1x1/wf.svg?00ae4e73cc902efd834cd13c4db05123";